import { Card, List, Avatar, Button, Badge, Popover, Flex } from "antd"
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

import { Guess } from "../types/Guess"

interface WinnerListProps {
    guesses: Guess[],
    rankAmount: number,
    onEdit: any,
    onDelete: any
}

export const WinnerList = ({ guesses, rankAmount, onEdit, onDelete }: WinnerListProps) => {
    return (
        <Card title="Sieger" className="winnerCard">
            {guesses.length === 0 ?
                (
                    <Flex className="infoMessage"><div>Starte <span className="infoPrimary">links</span> mit der Eingabe der Schätzungen.</div></Flex>
                ) :
                (
                    <List bordered dataSource={guesses} itemLayout="horizontal" renderItem={(item, index) => (
                        <List.Item className={index < rankAmount ? 'winnerItem' : ''}>
                            <span className="rankInfo">#{index + 1}</span>
                            <List.Item.Meta
                                className="winnerDescription"
                                avatar={<Avatar src={`https://xsgames.co/randomusers/avatar.php?g=pixel&key=${item.name}`} />}
                                title={
                                    <Popover content={<div className="infoPopup">Diese Schätzung (<span className="infoPrimary">{item.value}</span>) von <span className="infoPrimary">{item.name}</span> ist um <span className="infoPrimary">{item.distance}</span> vom Schätzwert entfernt und belegt somit den <span className="infoPrimary">{index + 1}. Platz</span>.</div>}>
                                        {item.name}
                                        <Badge className="distanceBadge" count={item.distance} overflowCount={item.distance} color="purple" />
                                    </Popover>
                                }
                                description={item.value} />

                            <Button className="itemButton edit" size="large" type="default" shape="circle" icon={<EditOutlined />} onClick={() => onEdit(item)} />
                            <Button className="itemButton delete" size="large" type="default" shape="circle" icon={<DeleteOutlined />} onClick={() => onDelete(item)} />
                        </List.Item>
                    )} />
                )
            }
        </Card>
    )
}